function StatementSection() {
  return (
    <section className="max-w-4xl mx-auto text-center px-6 py-8 lg:py-16">
      <h2 className="text-xl sm:text-2xl lg:text-4xl font-display font-medium text-gray-800 leading-snug">
       We help manufacturers build reliable electrical connections with{' '}
<span className="text-blue-700 border-b-2 border-blue-200"> custom wiring harnesses</span>,
<span className="text-blue-700 border-b-2 border-blue-200"> engineering support</span>, and
<span className="text-blue-700 border-b-2 border-blue-200"> dependable manufacturing</span>.
      </h2>
    </section>
  );
}

export default StatementSection;
